import { createContext, useContext } from 'react';
import { Map } from 'mapbox-gl';

interface MapContextType {
  map: Map | null;
}

export const MapContext = createContext<MapContextType>({
  // mapboxgl.Map instance
  map: null
});
if (process.env.NODE_ENV === 'development') {
  MapContext.displayName = 'MapContext';
}

export const useMap = (): Map | null => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error('useMap must be used within the MapContext.Provider');
  }
  return context.map;
};
